import { render, staticRenderFns } from "./deliverAnnouncement.vue?vue&type=template&id=74f514ee&scoped=true&"
import script from "./deliverAnnouncement.vue?vue&type=script&lang=js&"
export * from "./deliverAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./deliverAnnouncement.vue?vue&type=style&index=0&id=74f514ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f514ee",
  null
  
)

export default component.exports